export const xsmall = 'var(--cb-shadow-xsmall)';
export const small = 'var(--cb-shadow-small)';
export const medium = 'var(--cb-shadow-medium)';
export const large = 'var(--cb-shadow-large)';
